import styled from "styled-components";

const SpanPadding = styled.span`
  padding: 0 0.5rem;
`;

export default SpanPadding;
